export function flatMap<T, U>(array: T[], transformer: (x: T) => U[]): U[] {
  return array.reduce((x, y) => [...x, ...transformer(y)], [] as U[]);
}
